(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["betta-fish-content"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'tfBettaContentV6Blocks';
  if (window[key]) { window[key].scan(document); return; }
  const initialized = new WeakSet();
  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const tabs = [...root.querySelectorAll('[data-care]')];
    const panels = [...root.querySelectorAll('.tf-tabpanel')];
    function selectTab(tab, focus = false) {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => {
        const active = panel.id === tab.getAttribute('aria-controls');
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', String(!active));
      });
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); selectTab(tabs[next], true); }
      });
    });
    if (tabs.length) {
      selectTab(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
      root.dataset.tfTabsReady = 'true';
    }
    root.dataset.tfReady = 'true';

    const tracks = [...root.querySelectorAll('[data-scroll-track]')];
    function updateTrack(track) {
      const arrows = [...root.querySelectorAll('[data-scroll-target]')].filter(button => button.dataset.scrollTarget === track.id);
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      arrows.forEach(button => button.disabled = Number(button.dataset.scrollDirection) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2);
    }
    root.querySelectorAll('[data-scroll-target]').forEach(button => button.addEventListener('click', () => {
      const track = tracks.find(item => item.id === button.dataset.scrollTarget);
      if (!track) return;
      const child = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).gap) || 20;
      const distance = child ? child.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({left: distance * Number(button.dataset.scrollDirection), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    tracks.forEach(track => {
      track.addEventListener('scroll', () => updateTrack(track), {passive: true});
      track.querySelectorAll('img').forEach(image => image.addEventListener('load', () => updateTrack(track), {once: true}));
      updateTrack(track);
    });
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(() => tracks.forEach(updateTrack)) : null;
    if (resize) tracks.forEach(track => resize.observe(track));
    root.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => tracks.forEach(updateTrack)));

    root.querySelectorAll('[data-tf-product]').forEach(card => {
      const select = card.querySelector('[data-tf-variant]');
      if (!select) return;
      const form = card.querySelector('form');
      const button = card.querySelector('button[name="add"]');
      const feedback = card.querySelector('[data-tf-cart-feedback]');
      const viewCart = card.querySelector('[data-tf-cart-view]');
      let adding = false;
      const update = () => {
        const option = select.options[select.selectedIndex];
        const available = option?.dataset.available === 'true';
        const price = card.querySelector('[data-tf-price]');
        const quantity = card.querySelector('[name="quantity"]');
        const notice = card.querySelector('[data-tf-quantity-note]');
        const min = Number(option?.dataset.quantityMin) || 1;
        if (price && option) price.textContent = option.dataset.price;
        if (quantity) quantity.value = min;
        if (notice) { notice.hidden = min <= 1; notice.textContent = 'Adds ' + min + ' of the selected option (minimum quantity).'; }
        if (button) { button.disabled = adding || !available; button.textContent = adding ? 'Adding…' : available ? 'Add to cart' : 'Sold out'; }
      };
      select.addEventListener('change', () => {
        if (feedback) { feedback.textContent = ''; feedback.removeAttribute('data-error'); }
        if (viewCart) viewCart.hidden = true;
        update();
      });
      update();
      if (!form || !button || !feedback) return;
      // Capture this form's submission before theme handlers can submit it again.
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (adding || select.options[select.selectedIndex]?.dataset.available !== 'true') return;
        const body = new FormData(form);
        body.delete('return_to');
        const addUrl = new URL(form.action, location.href);
        addUrl.pathname = addUrl.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
        const badge = document.getElementById('cart-icon-bubble');
        if (badge) {
          body.set('sections', 'cart-icon-bubble');
          body.set('sections_url', location.pathname);
        }
        const wasDisabled = select.disabled;
        adding = true;
        select.disabled = true;
        form.setAttribute('aria-busy', 'true');
        feedback.textContent = '';
        feedback.removeAttribute('data-error');
        if (viewCart) viewCart.hidden = true;
        update();
        try {
          const response = await fetch(addUrl.href, {
            method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json'}, body
          });
          const result = await response.json().catch(() => null);
          if (!response.ok || Number(result?.status) >= 400) {
            const message = typeof result?.description === 'string' ? result.description : typeof result?.message === 'string' ? result.message : 'Unable to add this item. Please check your cart and try again.';
            throw new Error(message);
          }
          if (!result || (!result.id && !Array.isArray(result.items))) {
            throw new Error('We could not confirm the cart update. Check your cart before trying again.');
          }
          feedback.textContent = 'Added to cart. Keep exploring!';
          // Refresh supported theme cart badges without opening a drawer or changing pages.
          if (badge && typeof result.sections?.['cart-icon-bubble'] === 'string') {
            const parsed = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
            const freshBadge = parsed.getElementById('cart-icon-bubble') || parsed.querySelector('.shopify-section');
            if (freshBadge) badge.innerHTML = freshBadge.innerHTML;
          }
          card.dispatchEvent(new CustomEvent('tf:cart-added', {bubbles: true, detail: {item: result}}));
        } catch (error) {
          feedback.dataset.error = 'true';
          feedback.textContent = error instanceof TypeError ? 'We could not confirm the cart update. Check your cart before trying again.' : error.message || 'Unable to add this item. Please check your cart and try again.';
        } finally {
          adding = false;
          select.disabled = wasDisabled;
          form.removeAttribute('aria-busy');
          if (viewCart) viewCart.hidden = false;
          update();
        }
      }, true);
    });
    root.querySelectorAll('video').forEach(video => {
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.play().catch(() => {});
    });
    root.tfCleanup = () => resize?.disconnect();
  }
  function reveal(target, scroll) {
    const root = target.closest('[data-tf-betta-content]');
    if (!root) return;
    let ancestor = target;
    while (ancestor && ancestor !== root) {
      if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
    const panel = target.closest('.tf-tabpanel');
    if (panel) root.querySelector('[aria-controls="' + panel.id + '"]')?.click();
    if (scroll) requestAnimationFrame(() => target.scrollIntoView({block: 'start', behavior: 'auto'}));
  }
  function fromHash(scroll = true) {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (id) { const target = document.getElementById(id); if (target) reveal(target, scroll); }
  }
  function scan(scope) {
    if (scope.matches?.('[data-tf-betta-content]')) init(scope);
    scope.querySelectorAll('[data-tf-betta-content]').forEach(init);
  }
  window[key] = {scan};
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch { return; }
    if (!target?.closest('[data-tf-betta-content]')) return;
    event.preventDefault();
    const root = target.closest('[data-tf-betta-content]');
    if (link.dataset.careJump) root.querySelector('[data-care="' + link.dataset.careJump + '"]')?.click();
    history.replaceState(null, '', url.hash);
    reveal(target, true);
  });
  window.addEventListener('hashchange', () => fromHash());
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest?.('[data-tf-setup-block]');
    if (!card) return;
    card.scrollIntoView({block:'nearest', inline:'center', behavior:'auto'});
  });
  document.addEventListener('shopify:section:load', event => { scan(event.target); fromHash(false); });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-tf-betta-content]').forEach(root => root.tfCleanup?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { scan(document); fromHash(); }, {once: true});
  else { scan(document); fromHash(); }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
